import React from 'react';

import {
  ChevronDoubleDownIcon, ChevronDoubleUpIcon, ChevronDownIcon, ChevronUpIcon,
} from '@vlabs/icons';
import { Control } from '@vlabs/uikit';

import st from './OrderSelector.module.sass';
import type { TEventsColumns, TFacesColumns } from '../../types';

const moveElement = <T extends TFacesColumns | TEventsColumns>(
  arr: T[],
  from: number,
  to: number,
): T[] => {
  const element = arr.splice(from, 1)[0];
  if (element) arr.splice(to, 0, element);
  return arr;
};

interface OrderSelectorProps {
  list: TFacesColumns[] | TEventsColumns[];
  setList: (list: (TFacesColumns | TEventsColumns)[]) => void;
  keyMap?: Partial<Record<TFacesColumns | TEventsColumns, string>>;
}

export function OrderSelector({
  list,
  setList,
  keyMap = undefined,
}: OrderSelectorProps): React.JSX.Element {
  return (
    <div className={st.Wrapper}>
      {list.map((column, idx) => {
        return (
          <div
            className={st.Item}
            key={column}
          >
            {keyMap?.[column] ?? column}
            <div className={st.Controls}>
              {idx === 0 && (
                <React.Fragment>
                  <div className={st.Empty} />
                  <div className={st.Empty} />
                </React.Fragment>
              )}
              {idx > 0 && (
                <React.Fragment>
                  <Control.Button
                    className={st.Up}
                    onClick={() => {
                      setList([...moveElement(list, idx, 0)]);
                    }}
                    variant="dimmed"
                  >
                    <ChevronDoubleUpIcon />
                  </Control.Button>
                  <Control.Button
                    className={st.Up}
                    onClick={() => {
                      setList([...moveElement(list, idx, idx - 1)]);
                    }}
                    variant="dimmed"
                  >
                    <ChevronUpIcon />
                  </Control.Button>
                </React.Fragment>
              )}
              {idx === list.length - 1 && (
                <React.Fragment>
                  <div className={st.Empty} />
                  <div className={st.Empty} />
                </React.Fragment>
              )}
              {idx < list.length - 1 && (
                <React.Fragment>
                  <Control.Button
                    className={st.Down}
                    onClick={() => {
                      setList([...moveElement(list, idx, idx + 1)]);
                    }}
                    variant="dimmed"
                  >
                    <ChevronDownIcon />
                  </Control.Button>
                  <Control.Button
                    className={st.Down}
                    onClick={() => {
                      setList([...moveElement(list, idx, list.length - 1)]);
                    }}
                    variant="dimmed"
                  >
                    <ChevronDoubleDownIcon />
                  </Control.Button>
                </React.Fragment>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
